export default class AnimationMappings {
    static PlayerAnimations = class PlayerAnimations {
        public static NAME_IDLE = "Character|Idle";
        public static NAME_WALK = "Character|Walk";
        public static NAME_RUN = "Character|Run";
        public static NAME_WAVE = "Character|Wave";
        public static NAME_JUMP = "Character|Jump";

        public static SPEED_IDLE = 1;
        public static SPEED_WALK = 1.7;
        public static SPEED_RUN = 1.2;
        public static SPEED_WAVE = 1;
        public static SPEED_JUMP = 1;
    };
}
